import { __decorate, __extends } from "tslib";
import { Divider, TextButton, Modal } from 'wix-style-react';
import * as React from 'react';
import s from './category-header-mobile.scss';
import { SubCategoriesSelectorModalMobile } from './sub-categories-selector-modal-mobile';
import { SelectorTagMobile } from './selector-tag-mobile';
import { withTranslation } from '../../../component-decorators/with-translation';
var SubCategoriesSelectorMobile = /** @class */ (function (_super) {
    __extends(SubCategoriesSelectorMobile, _super);
    function SubCategoriesSelectorMobile(props) {
        var _this = _super.call(this, props) || this;
        _this.openModal = function () { return _this.setState({ isModalOpened: true }); };
        _this.closeModal = function () { return _this.setState({ isModalOpened: false }); };
        _this.setCheckedSubCategories = function (subCategories) {
            _this.setState({ checkedSubCategories: subCategories });
        };
        _this.state = {
            isModalOpened: false,
            checkedSubCategories: [],
        };
        _this.setCheckedSubCategories = _this.setCheckedSubCategories.bind(_this);
        _this.openModal = _this.openModal.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        return _this;
    }
    SubCategoriesSelectorMobile.prototype.render = function () {
        var _a = this.props, subCategories = _a.subCategories, categoryName = _a.categoryName, name = _a.name, t = _a.t;
        var _b = this.state, isModalOpened = _b.isModalOpened, checkedSubCategories = _b.checkedSubCategories;
        return (React.createElement("div", { "data-testid": 'sub-categories-selector-mobile', className: s.subCategoriesSelector },
            checkedSubCategories && checkedSubCategories.length ? (React.createElement("div", { className: s.selectorsChecked }, checkedSubCategories.map(function (subCategory) {
                return (React.createElement(SelectorTagMobile, { name: subCategory.name, key: subCategory.slug }));
            }))) : (React.createElement(React.Fragment, null,
                React.createElement(SelectorTagMobile, { name: t('category.filter-subcategory.all'), slug: 'all' }),
                React.createElement("div", { className: s.selectorsDividerAll },
                    React.createElement(Divider, { direction: 'vertical', skin: 'light' })))),
            React.createElement(TextButton, { skin: 'light', size: 'small', weight: 'normal', onClick: this.openModal, underline: 'always' }, t('category-header-mobile.filter-subcategory.title')),
            React.createElement(Modal, { isOpen: isModalOpened, onRequestClose: this.closeModal, scrollableContent: true },
                React.createElement(SubCategoriesSelectorModalMobile, { subCategories: subCategories, checkedSubCategories: this.state.checkedSubCategories, setCheckedSubCategories: this.setCheckedSubCategories, categoryName: categoryName, name: name, closeModal: this.closeModal }))));
    };
    SubCategoriesSelectorMobile = __decorate([
        withTranslation
    ], SubCategoriesSelectorMobile);
    return SubCategoriesSelectorMobile;
}(React.Component));
export { SubCategoriesSelectorMobile };
//# sourceMappingURL=sub-categories-selector-mobile.js.map